import React from 'react'
import parse from 'html-react-parser'

import { hasErrors } from './'
import FormError from './FormError'

const CheckboxField = ({ field, id, form, ...props }) => {
  const { text, cy } = props
  const { name, value, onBlur } = field
  return (
    <>
      <div>
        <label className="inline-flex items-center mb-3">
          <input
            type="checkbox"
            className="form-checkbox text-secondary h-10 w-10 bg-primary-lighter border-transparent cursor-pointer"
            name={name}
            id={id}
            data-cy={cy}
            checked={value === '1'}
            onChange={() => {
              if (field.value === '0') {
                form.setFieldValue(name, '1')
              } else {
                form.setFieldValue(name, '0')
              }
            }}
            onBlur={onBlur}
          />
          <span className="ml-4">{parse(text)}</span>
        </label>
        {hasErrors({ field, form }) && <FormError error={form.errors[name]} />}
      </div>
    </>
  )
}

export default CheckboxField
